import * as CurrentUserConstants from "../constants/CurrentUser";

const initialState = {
  isFetchingAisToken: false,
  aisToken: undefined
};

export function currentUser(state = initialState, action) {
  switch (action.type) {
    case CurrentUserConstants.FETCH_AIS_TOKEN_STARTED:
      return Object.assign({}, state, {isFetchingAisToken: true, aisToken: undefined});
    case CurrentUserConstants.FETCH_AIS_TOKEN_COMPLETED:
      return Object.assign({}, state, {isFetchingAisToken: false, aisToken: action.aisToken});
    default:
      return state;
  }
}
